export default __webpack_public_path__ + "static/media/logo-color.dac7e166.png";